import { useUser } from '@portals-platform/auth';
import { Button, PageHeader, SectionCard } from '@portals-platform/ui';
import { useNavigate } from '@tanstack/react-router';
import { PlusIcon } from 'lucide-react';
import { CertificateSummaryCards } from '../components/certificates-table/certificate-summary-cards.js';
import { CertificatesTable } from '../components/certificates-table/certificates-table.js';
import { PortalShell } from '../components/portal-shell.js';
import { useCertificateSearch } from '../data-access/index.js';

function getGreeting(date: Date): string {
  const hour = date.getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

function getQuarterLabel(date: Date): string {
  return `Q${Math.floor(date.getMonth() / 3) + 1} ${date.getFullYear()}`;
}

export function AdminDashboardPage() {
  const navigate = useNavigate();
  const name = useUser()?.name;
  const now = new Date();
  const greeting = getGreeting(now);
  const { countsByStatus, totalElements } = useCertificateSearch({ page: 0, size: 1 });

  return (
    <PortalShell activeId="overview" pageTitle="Overview">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          eyebrow={
            <>
              <span
                aria-hidden="true"
                className="inline-block size-1.5 rounded-full"
                style={{
                  // Was `bg-green-500` with an rgba halo — a Tailwind palette colour and a
                  // literal, neither of which a brand can theme.
                  background: 'var(--color-success)',
                  boxShadow: '0 0 0 4px color-mix(in oklab, var(--color-success) 25%, transparent)',
                }}
              />
              Live · {getQuarterLabel(now)} · All programs
            </>
          }
          title={name ? `${greeting}, ${name}` : greeting}
          actions={
            <Button onClick={() => navigate({ to: '/certificates/new' })}>
              <PlusIcon aria-hidden="true" />
              Create certificate
            </Button>
          }
        />

        <CertificateSummaryCards
          totalElements={totalElements}
          countsByStatus={countsByStatus}
          className="mb-6"
        />

        <SectionCard
          title="Latest certificates"
          description="Most recently created"
          action={
            <Button variant="outline" size="sm" onClick={() => navigate({ to: '/certificates' })}>
              View all
            </Button>
          }
          flush
        >
          <CertificatesTable compact />
        </SectionCard>
      </div>
    </PortalShell>
  );
}
